import { render, staticRenderFns } from "./TimesheetGroupTabs.vue?vue&type=template&id=5040a8b1&scoped=true&"
import script from "./TimesheetGroupTabs.vue?vue&type=script&lang=js&"
export * from "./TimesheetGroupTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5040a8b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Ampps\\www\\excavation\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5040a8b1')) {
      api.createRecord('5040a8b1', component.options)
    } else {
      api.reload('5040a8b1', component.options)
    }
    module.hot.accept("./TimesheetGroupTabs.vue?vue&type=template&id=5040a8b1&scoped=true&", function () {
      api.rerender('5040a8b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/resources/js/components/timesheet/group/TimesheetGroupTabs.vue"
export default component.exports